export const getKeyValidationMessage = (key: string): string | undefined => {
  if (/^(?![A-Za-z0-9_-]+$)/.test(key)) {
    return "Only a-z, A-Z, 0-9, '-' and '_' are allowed.";
  }
  return undefined;
};

export const thisFieldIsEmptyMessage = 'This field should not be empty.';

export const getEmptyInputMessage = (value: string): string | undefined => {
  if (value === '') {
    return thisFieldIsEmptyMessage;
  }
  return undefined;
};

export const getAuthorizationKeyMessage = (
  value: string,
): string | undefined => {
  if (value.toLowerCase() === 'authorization') {
    return "'Authorization' is not allowed as key. Please use the field above.";
  }
  return undefined;
};

export const isValidateCustomHeaders = (
  customHeader: Dictionary<string>,
): boolean | undefined =>
  customHeader &&
  (Object.keys(customHeader).some((key) => getKeyValidationMessage(key)) ||
    Object.keys(customHeader).some((key) => getAuthorizationKeyMessage(key)) ||
    Object.values(customHeader).some((value) => getEmptyInputMessage(value)))
    ? false
    : undefined;

export const isResponseWithErrors = (
  response: unknown,
): response is { errors: string[] } =>
  Boolean(typeof response === 'object' && response && 'errors' in response);

export const validateUrlUsesHttps = (url?: string): string | undefined => {
  if (url && !url.toLowerCase().startsWith('https://')) {
    return "The URL must start with 'https://'.";
  }
  return undefined;
};

export const validateNotOnlyWhitespace = <TInputValue>(
  input: TInputValue,
): true | string =>
  typeof input === 'string'
    ? input.trim().length > 0 ||
      'Whitespace is not considered a value. Please enter a real value.'
    : true;
